import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {GameWidgetApiModel} from "./game-widget.api-model";

export class GameWidgetDomainModel extends BaseDomainModel {
  provider: String;
  partnerId: String;
  url: String;
  ratio: String;
  type: String;

  constructor(apiModel: GameWidgetApiModel) {
    super(apiModel);

    this.provider = apiModel.provider;
    this.partnerId = apiModel.partnerId;
    this.url = apiModel.widgetUrl;
    this.ratio = apiModel.widgetRatio;
    this.type = apiModel.widgetType;
  }
}